import { AssetType } from '@modules/cards/types/asset.types';
import { SortOptionInterface } from '@modules/shared/interfaces/sort-option.interface';

export const ENTITY_SORT_OPTIONS: { [k in AssetType]: SortOptionInterface[] } = {
  DOCUMENT: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  TECHNICAL_DATA: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  IMAGE: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  PRESS_INFORMATION: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  PRESS_KIT: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  VIDEO: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  AUDIO: [
    {
      label: 'DATE_DESC',
      value: 'display_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'display_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  MEDIA_COLLECTION: [],
  MEDIA_SPECIAL: [
    {
      label: 'DATE_DESC',
      value: 'creation_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'creation_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  EVENT: [
    {
      label: 'DATE_DESC',
      value: 'start_date',
      order: 'DESC',
    },
    {
      label: 'DATE_ASC',
      value: 'start_date',
      order: 'ASC',
    },
    {
      label: 'TITLE_DESC',
      value: 'title',
      order: 'DESC',
    },
    {
      label: 'TITLE_ASC',
      value: 'title',
      order: 'ASC',
    },
  ],
  PRESS_CONTACT: [
    {
      label: 'CONTACTS_PAGE_FILTER_LAST_NAME_ASC',
      value: 'last_name',
      order: 'ASC',
    },
    {
      label: 'CONTACTS_PAGE_FILTER_LAST_NAME_DESC',
      value: 'last_name',
      order: 'DESC',
    },
    {
      label: 'CONTACTS_PAGE_FILTER_FIRST_NAME_ASC',
      value: 'first_name',
      order: 'ASC',
    },
    {
      label: 'CONTACTS_PAGE_FILTER_FIRST_NAME_DESC',
      value: 'first_name',
      order: 'DESC',
    },
  ],
};
export const SEARCH_RELEVANCY_SORT_OPTIONS: SortOptionInterface[] = [
  {
    label: 'RELEVANCE',
    value: 'search_relevancy',
    order: 'DESC',
  },
];
